import type {BioIconProps} from '../common-types'

export function EditorsChoiceEyeIcon({...attributes}: BioIconProps) {
  return (
    <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <g clipPath="url(#clip0_154_48092)">
        <path
          d="M10.2521 6.05823C4.12109 6.05823 1.54688 11.5727 1.54688 11.6869C1.54688 11.8012 4.12109 17.3142 10.2521 17.3142C16.383 17.3142 18.9572 11.8012 18.9572 11.6869C18.9572 11.5727 16.383 6.05823 10.2521 6.05823Z"
          strokeWidth="1.46429"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.17735 9.26182L0.894531 6.97607"
          strokeWidth="1.46429"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M7.51967 6.45784L6.58984 3.44873" strokeWidth="1.46429" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M17.3242 9.26164L19.607 6.97736" strokeWidth="1.46429" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.9805 6.45784L13.9103 3.44873" strokeWidth="1.46429" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M7.77177 11.1184C7.62111 11.7763 7.73798 12.4672 8.09667 13.0389C8.45537 13.6107 9.0265 14.0165 9.68442 14.1672C10.3424 14.3179 11.0332 14.201 11.6049 13.8423C12.1767 13.4836 12.5825 12.9125 12.7332 12.2546C12.8839 11.5966 12.767 10.9058 12.4083 10.334C12.0496 9.76228 11.4785 9.35643 10.8206 9.20576C10.1626 9.0551 9.4718 9.17197 8.90005 9.53066C8.32829 9.88936 7.92244 10.4605 7.77177 11.1184Z"
          strokeWidth="1.46429"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_154_48092">
          <rect width="20.5" height="20.5" fill="white" transform="translate(0 0.75)" />
        </clipPath>
      </defs>
    </svg>
  )
}
